import React from "react";
import { ThreeDots } from "react-loader-spinner";
import SortableDataTable from "./SortableDataTable";
import Badge from "./Badge";
import TruncateText from "./TruncateText";
import {
  displayFormatDate,
  formatDate,
  formatLeaveType,
  formatToDateOnly,
} from "../utils/helpers";
import NoRecordsAvailable from "./NoRecordsAvailable";
import { LEAVE_TYPES } from "../constants/leaveTypes";
import { ENTRY_LABELS } from "../constants/leaveRequestHistoryEntryLabels";

const LeaveRequestHistoryModal = ({ ledgerData = [], loading }) => {
  const LEDGER_LEAVE_TYPES = {
    PL: "Privilege Leave",
    CL: "Casual Leave",
    WFH: "Work From Home",
    HALF_DAY: "Half Day Leave",
    UNPAID: "Unpaid Leave",
  };

  const getLeaveTypeLabel = (value) => {
    return LEDGER_LEAVE_TYPES[value] || value || "-";
  };
  const columns = [
    {
      label: "Applied Date",
      key: "created_at",
      render: (row) =>
        displayFormatDate(formatToDateOnly(new Date(row.createdAt))),
      compare: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      label: "Leave Type",
      key: "leave_type_affected",
      render: (row) => getLeaveTypeLabel(row.leaveTypeAffected),
    },
    {
      label: "Entry",
      key: "entry_type",
      render: (row) => (
        <Badge type={row.entryType === "DEBIT" ? "danger" : "success"}>
          {ENTRY_LABELS[row.entryType] || row.entryType}
        </Badge>
      ),
    },
    {
      label: "Amount",
      key: "amount",
    },
    {
      label: "Balance After Deduction",
      key: "balanceAfter",
    },
    {
      label: "Remarks",
      key: "remarks",
      maxWidth: "260px",
      sortable: false,
      showTooltip: true,
      render: (row) => row.remarks || "-",
    },
  ];

  return (
    <div
      className="modal fade"
      id="viewLedgerModal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header justify-content-center position-relative p-2">
            <h5 className="modal-title">Leave Deduction Details</h5>
            <button
              className="btn-close position-absolute end-0 me-3"
              data-bs-dismiss="modal"
            />
          </div>

          <div className="modal-body">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center p-5">
                <ThreeDots
                  height="80"
                  width="80"
                  radius="9"
                  color="#0675d6"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            ) : ledgerData.length === 0 ? (
              <NoRecordsAvailable />
            ) : (
              <SortableDataTable
                columns={columns}
                data={ledgerData}
                currentPage={1}
                limit={ledgerData.length}
                className="rounded-lg"
                showSerial={false}
                allowTooltipOverflow={true}
                sortable={false}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveRequestHistoryModal;
